import { resolveLink as n } from "../../../helpers/index.js";
const o = (e) => {
  const r = [];
  return e?.forEach((i) => {
    i?.items.forEach((t) => {
      r.push({
        header: t.content.properties?.header,
        text: t.content.properties?.text,
        cta: t.content.properties?.link && n(t.content.properties?.link?.[0])
      });
    });
  }), r;
}, p = (e) => ({
  header: e.properties?.header || "",
  items: o(e.areas),
  link: e.properties?.link && n(e.properties?.link?.[0])
});
export {
  p as benefitsDeliveryApiParser
};
